import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog/AlertDialog";
import { format } from "date-fns";
import { useRotations } from "../../hooks/rotations/useRotations";

const UnarchiveRotationDialog = ({
  open,
  onOpenChange,
  rotation,
  onUnarchived,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  rotation: any;
  onUnarchived: () => void;
}) => {
  const { unarchiveRotation, loading } = useRotations();

  const onUnarchive = async () => {
    const result = await unarchiveRotation(rotation._id);
    if (!result) return;
    onUnarchived();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Restore {format(rotation.date, "MMMM dd, yyyy")} Rotation
          </AlertDialogTitle>
          <AlertDialogDescription>
            Unarchiving will restore this rotation and all its descendants to
            active views. Students and teachers will see it again.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading.unarchiveRotation}>
            {loading.unarchiveRotation ? "Loading..." : "Cancel"}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onUnarchive}
            disabled={loading.unarchiveRotation}
          >
            {loading.unarchiveRotation ? "Loading..." : "Restore Rotation"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export { UnarchiveRotationDialog };
